// src/pages/Settings/Settings.js
import React from 'react';

const Settings = () => {
    return (
        <div>
            <h1>Settings</h1>
            <p>This is the settings page. Only authenticated users can see this.</p>
        </div>
    );
};

export default Settings;
